import callApi from '../../utils/api';
import { API_BASE_URL } from '../../utils/constants';
import { parseParams } from '../../utils'

const api = callApi(API_BASE_URL || "");
const pageSize = 1500;

const imageUploadParams = new URLSearchParams({
    fileCategory: 'MASTER_SERVICE',
    subFolders: 'STUDENTS',
    fileType: 'templateUrl'
});

const studentFileTypeMap = {
    thumbnailUrl: 'THUMBNAIL_URL',
    imageUrl: 'IMAGE_URL',
    templateURL: 'CERTIFICATE',
}

export const GET_STUDENT_ALL_BY_TEACHER = '/v1/api/user/students/ir/teacher-section-grade-based?{{query}}';
export const GET_STUDENT_BY_ID = '/v1/api/user/students/{{id}}';
export const GET_GRADE_BY_TEACHER = '/v1/api/user/teachers/assigned-grades?{{query}}'

export const ADD_ASSESSMENT_RESULT = '/v1/api/master/assessments/studentAssessmentResult/{{assessmentId}}/{{id}}'
export const GET_ASSESSMENT_RESULT = '/v1/api/master/assessments/studentAssessmentResult/{{assessmentId}}/{{id}}';


//Activity
export const GET_STUDENT_BY_COURSE_ACTIVITY = '/v1/api/master/assignmentProgress/activity/{{courseId}}/{{id}}'
export const GET_PROGRESS_SUMMARY_COURSE_ID = '/v1/api/master/assignmentProgress/progressSummary/{{courseId}}/{{id}}'
export const GET_ASSESSMENT_SUMMARY_COURSE_ID = '/v1/api/master/assignmentProgress/assessmentSummary/{{courseId}}/{{id}}'
export const GET_ASSIGNMENT_PROGRESS_COURSE_ID = '/v1/api/master/assignmentProgress/{{courseId}}/{{id}}'

export const ONBOARD_STUDENT = '/v1/api/master/courses/onboard';
export const APPROVE_STUDENT = '/v1/api/master/courses/users/approve'
export const PROMOTE_STUDENT = '/v1/api/master/courses/users/promote'



export const getAll = async (payload) => {

    // pageSize must be <= 50 per backend @Max(50) on this endpoint.
    let paramConstant = { pageNumber: 0, pageSize: 50, sortOrder: true, sortBy: "createdAt" }
    let query = paramConstant;

    if (payload && payload.payload) {
        query = { ...payload.payload, ...query };
    }
    let params = new URLSearchParams(query).toString();
    return await api.get(parseParams(GET_STUDENT_ALL_BY_TEACHER, { query: params }));
}

export const getAllWithoutPage = async (payload) => {
    let pageSize = 100
    let query = { pageSize };
    if (payload && payload.payload) {
        query = { ...payload.payload, ...query };
    }
    let params = new URLSearchParams(query).toString();
    return await api.get(parseParams(GET_STUDENT_ALL_BY_TEACHER, { query: params }));
}
export const getById = async (payload) => api.get(parseParams(GET_STUDENT_BY_ID, payload));
export const getStudentActivity = async (payload) => await api.get(
    parseParams(GET_STUDENT_BY_COURSE_ACTIVITY, payload)
);

export const getAssessmentSummaryByCourseAndId = async (payload) => {
    const url = parseParams(GET_ASSESSMENT_SUMMARY_COURSE_ID, payload);
    // Student self view (/my-activity) passes passedOnly so only passed attempts return.
    return await api.get(payload?.passedOnly ? `${url}?passedOnly=true` : url);
};

export const getProgressSummaryByCourseAndId = async (payload) => await api.get(
    parseParams(GET_PROGRESS_SUMMARY_COURSE_ID, payload)
);

export const getAssignmentProgressByCourseAndId = async (payload) => await api.get(
    parseParams(GET_ASSIGNMENT_PROGRESS_COURSE_ID, payload)
);


export const getGradeByTeacher = async (payload) => {

    let query = {};
    if (payload && payload.payload) {
        query = { ...payload.payload, ...query };
    }
    let params = new URLSearchParams(query).toString();
    return await api.get(parseParams(GET_GRADE_BY_TEACHER, { query: params }));
}

export const addAssessmentResultPreview = async (payload) => await api.post(parseParams(ADD_ASSESSMENT_RESULT, payload.params), payload.body);
export const getAssessmentResultPreview = async (payload) => await api.get(parseParams(GET_ASSESSMENT_RESULT, payload));

export const onboardStudent = async (payload) => api.post(ONBOARD_STUDENT, payload);
export const approveStudent = async (payload) => api.post(APPROVE_STUDENT, payload);
export const promoteStudent = async (payload) => api.post(PROMOTE_STUDENT, payload);




